import * as PropertyBucket from '../../Properties/Properties.js';
import * as httpService from '../../Components/HttpService/HttpService';

export function getProgsDataRequested() {
    return {
        type: 'GET_PROGS_DATA_REQUESTED'
    };
}

export function getProgsDataDone(data) {
    return {
        type: 'GET_PROGS_DATA_DONE',
        payload: data
    };
}

export function getProgsDataFailed(error) {
    return {
        type: 'GET_PROGS_DATA_FAILED',
        payload: error
    };
}

export function getProgramsData(successCallback) {
    const programsFromSS = localStorage.getItem("programs") && localStorage.getItem("programs") !== 'undefined' ? JSON?.parse(localStorage.getItem("programs")) : null;

    if (programsFromSS !== null) {
        return dispatch => {
            dispatch(getProgsDataDone(programsFromSS));
            if (successCallback) {
                successCallback();
            }

            return Promise.resolve();
        };
    }

    const url = PropertyBucket.getPrograms();
    return dispatch => {
        dispatch(getProgsDataRequested());

        return httpService.getService(url, "GET")
            .then(data => {
                localStorage.setItem("programs", JSON.stringify(data));
                dispatch(getProgsDataDone(data));
                if (successCallback) {
                    successCallback();
                }
            })
            .catch(error => {
                dispatch(getProgsDataFailed(error));
                throw error;
            });
    };
}

export function setSelectedProgsData(data) {
    localStorage.setItem("selectedProgram", JSON.stringify(data));
    return {
        type: 'SET_SELCTED_PROGS_DATA',
        payload: data
    };
}

export const GET_PROGS_DATA_REQUESTED = 'GET_PROGS_DATA_REQUESTED';
export const GET_PROGS_DATA_DONE = 'GET_PROGS_DATA_DONE';
export const GET_PROGS_DATA_FAILED = 'GET_PROGS_DATA_FAILED';
export const SET_SELCTED_PROGS_DATA = 'SET_SELCTED_PROGS_DATA';